<div class="drag-drop-container" (dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

    @if (isDragging()) {
      <div class="drag-overlay">
        <div class="drag-content">
          <span class="material-symbols-outlined drag-icon">cloud_upload</span>
          <h2>Rilascia qui i file</h2>
          <p>Destinazione: <strong>{{ currentPath() }}</strong></p>
        </div>
      </div>
    }

    <app-document-table 
        [subtitle]="rootFolderName() ? 'Indice: ' + rootFolderName() : 'Seleziona una cartella indice'" 
        [basePath]="'input/'" 
        [documents]="documents()"
        [isLoading]="isLoading()" 
        (pathChanged)="currentPath.set($event)"
        [showIngestButton]="true"
        [ingestEnabled]="canRunIngestion()"
        [isProcessing]="isProcessing()" 
        (ingestClicked)="openIngestionModal()"
        [hasError]="hasError()"
        [showSelection]="true" 
        (selectionChanged)="onSelectionChanged($event)">

        <div table-actions class="upload-dropdown-container">
            
            <button class="btn-upload" (click)="toggleUploadMenu()" [disabled]="isUploading() || !isInFolder()">
                <span class="material-symbols-outlined">cloud_upload</span>
                Carica...
            </button>

            @if (selectedItems().length > 0) {
              <div class="selection-counter">
                <span class="text-muted fw-bold counter-text">
                  {{ selectedItems().length }} selezionati
                </span>
              </div>
            }

            @if (isUploadMenuOpen()) {
                <div class="click-outside-backdrop" 
                     (click)="isUploadMenuOpen.set(false)"
                     (keydown.enter)="isUploadMenuOpen.set(false)"
                     tabindex="-1"
                     aria-hidden="true"></div>
                     
                <div class="upload-dropdown-menu">
                    <button (click)="triggerFileInput(fileInput)">File</button>
                    <button (click)="triggerFileInput(folderInput)">Cartella</button>
                </div>
            }

            <input type="file" #fileInput multiple hidden (change)="onFilesSelected($event)">
            <input type="file" #folderInput webkitdirectory directory multiple hidden (change)="onFilesSelected($event)">
        </div>
    </app-document-table>
</div>

@if (isUploading()) {
    <div class="upload-progress-overlay">
        <div class="progress-card shadow-lg text-center p-4">
            <h3 class="mb-3">Upload in corso...</h3>
            <p class="mb-2">{{ uploadProgress().completed }} / {{ uploadProgress().total }} file</p>
            <div class="progress-bar-container">
                <div class="progress-bar" [style.width.%]="(uploadProgress().completed / (uploadProgress().total || 1)) * 100"></div>
            </div>
        </div>
    </div>
}